import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { noop } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import T from '@prisjakt/ui-translate';
import { toggleMobile } from '../../../../actions/filter';

import * as S from './styles';
import Counter from '../counter';

const FilterMobileToggle = props => {
  const { isOpen, onClick, filterSettings } = props;
  const count = Object.keys(filterSettings).length;

  return (
    <S.FilterMobileToggle>
      <Button
        style={{ width: '100%' }}
        onClick={() => onClick(!isOpen)}
        color="primary"
        icon={count > 0 && <Counter count={count} />}
      >
        <T domain="filter">button.filter</T>
      </Button>
    </S.FilterMobileToggle>
  );
};

const { bool, func, object } = PropTypes;
FilterMobileToggle.propTypes = {
  isOpen: bool,
  filterSettings: object, // eslint-disable-line react/forbid-prop-types
  onClick: func,
};

FilterMobileToggle.defaultProps = {
  isOpen: noop,
  filterSettings: {},
  onClick: noop,
};

export default connect(
  state => ({
    isOpen: state.areas.category.filter.mobileOpen,
  }),
  { onClick: toggleMobile }
)(FilterMobileToggle);
